import React from 'react';
export const ProjectContext = React.createContext(null);
export const SubjectsContext = React.createContext(null);
export const ScopeComponentsContext = React.createContext(null);
export const ProjectFilesContext = React.createContext(null);
export const ProjectNavigationTreeContext = React.createContext(null);
export const ReportContext = React.createContext(null);
export const RequestsContext = React.createContext(null);
export const RequestEditorContext = React.createContext(null);
export const ProjectCreateContext = React.createContext(null);
export const RequestContext = React.createContext(null);
export const RequestsNavigationContext = React.createContext(null);